// Работа с локальным временем и таймзонами — только через Luxon, руками не считать.
import { DateTime } from 'luxon';
import type { FlightSegment } from '../types';
import { createTranslator, type Translate } from '../i18n/translations';

/** Язык по умолчанию для вызовов вне UI (тесты, серверные утилиты). */
const defaultT: Translate = createTranslator('ru');

/**
 * Локальное ISO-время (без офсета) + IANA таймзона -> unix millis (UTC).
 * null если tz пустая/невалидная или local не парсится.
 */
export function toUtcMillis(local: string, tz: string): number | null {
  if (!tz) return null;
  if (!local) return null;
  const dt = DateTime.fromISO(local, { zone: tz });
  if (!dt.isValid) return null;
  return dt.toUTC().toMillis();
}

/** Длительность рейса в минутах через UTC. null если таймзоны неизвестны/невалидны. */
export function flightDurationMin(f: FlightSegment): number | null {
  const departUtc = toUtcMillis(f.departLocal, f.fromTz);
  const arriveUtc = toUtcMillis(f.arriveLocal, f.toTz);
  if (departUtc === null || arriveUtc === null) return null;
  return Math.round((arriveUtc - departUtc) / 60000);
}

/** 250 -> '4ч10м' / '4h10m', 45 -> '45м', 0 -> '0м', 120 -> '2ч', -30 -> '-30м'. */
export function formatDuration(min: number, t: Translate = defaultT): string {
  const hour = t('labels.hour');
  const minute = t('labels.minute');
  const sign = min < 0 ? '-' : '';
  const abs = Math.abs(min);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  if (h === 0) return `${sign}${m}${minute}`;
  if (m === 0) return `${sign}${h}${hour}`;
  // Минуты дополняются нулём: это табличные данные, колонки должны совпадать.
  return `${sign}${h}${hour}${String(m).padStart(2, '0')}${minute}`;
}

/** '2026-12-27T11:55' -> '27.12 11:55'. */
export function formatLocal(local: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(local);
  if (!m) return local;
  const [, , month, day, hour, minute] = m;
  return `${day}.${month} ${hour}:${minute}`;
}
